 export const colors = [
  {primary: '#151521', secondary:'#E6E6E6', paper: '#FAF9F6', default:'#FAF9F6', logo:'#151521'},
  {primary: '#B6C2AA', secondary:'#EDFA90', paper: '#999999', default:'#454D57', logo:'#B6C2AA'},
  {primary: '#151521', secondary:'#ffffff', paper: '#454D57', default:'#999999', logo:'#151521'},
  {primary: '#B6C2AA', secondary:'#EDFA90', paper: '#999999', default:'#454D57', logo:'#B6C2AA'},
  {primary: '#204F2B', secondary:'#FFFE55', paper: '#F7F7F7', default:'#F7F7F7', logo:'#204F2B'},
  {primary: '#151521', secondary:'#E9B352', paper: '#454D57', default:'#999999', logo:'#151521'},
]
